// @flow

import gql from 'graphql-tag';

export default gql`
  fragment serviceActionMetadata on Service {
    description
    hasFilters
    hasReads
    hasSearches
    hasSearchesOrWrites
    hasWrites
  }
`;
